import { useState } from "react";

const FORM_ID = "subscribe-form";
const SUBMIT_ADDR = "https://readdy.ai/api/form/daiipn3oh653ivfvoe1g";

const focusOptions = [
  "综艺现场话题",
  "影视片场话题",
  "网络风波话题",
  "品牌代言话题",
  "电竞圈话题",
  "音乐现场话题",
];

export default function SubscribeForm() {
  const [status, setStatus] = useState<"idle" | "sending" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");
  const [note, setNote] = useState("");

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const payload = new FormData(form);

    const trap = String(payload.get("website_alt") || "").trim();
    if (trap) {
      setStatus("success");
      setFormError("");
      form.reset();
      setNote("");
      return;
    }

    payload.delete("website_alt");

    const body = new URLSearchParams();
    payload.forEach((value, key) => {
      body.append(key, String(value));
    });

    setStatus("sending");
    setFormError("");

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });

      const responseText = await response.text();
      let parsed: {
        code?: string;
        message?: string;
        meta?: { message?: string; detail?: string };
      } | null = null;

      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const code = parsed?.code || "";
      const spamLike = /spam|form data is spam/i.test(serverMsg);

      if (response.ok && code === "OK" && !spamLike) {
        setStatus("success");
        setFormError("");
        form.reset();
        setNote("");
      } else {
        setStatus("error");
        setFormError(serverMsg || "提交失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setFormError("网络异常，提交失败，请检查网络后重试。");
    }
  };

  return (
    <form
      id={FORM_ID}
      data-readdy-form
      action={SUBMIT_ADDR}
      method="post"
      onSubmit={handleSubmit}
      className="mt-6 w-full"
    >
      <div className="flex flex-col gap-3 sm:flex-row">
        <label htmlFor="subscribe-email" className="sr-only">
          邮箱地址
        </label>
        <input
          id="subscribe-email"
          type="email"
          name="email"
          required
          placeholder="your@email.com"
          className="flex-1 rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-950 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-500"
        />
        <label htmlFor="subscribe-focus" className="sr-only">
          关注方向
        </label>
        <select
          id="subscribe-focus"
          name="focus"
          defaultValue={focusOptions[0]}
          className="rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-950 outline-none focus:border-primary-500 sm:w-44"
        >
          {focusOptions.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </select>
        <button
          type="submit"
          disabled={status === "sending"}
          className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {status === "sending" ? "提交中…" : "订阅更新"}
        </button>
      </div>

      <div className="mt-3">
        <label htmlFor="subscribe-note" className="mb-1.5 block text-xs text-foreground-500">
          想补充的线索或想纠正的信息（选填，最多 500 字）
        </label>
        <textarea
          id="subscribe-note"
          name="message"
          maxLength={500}
          value={note}
          onChange={(event) => setNote(event.target.value)}
          rows={3}
          placeholder="例如：某条话题的素材层级标注可能有误，希望能补充说明……"
          className="w-full resize-none rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-950 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-500"
        />
        <div className="mt-1 text-right text-xs text-foreground-400">{note.length}/500</div>
      </div>

      <input
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="form-detect-field"
      />

      {status === "success" && (
        <p className="mt-3 rounded-md bg-secondary-100 px-4 py-3 text-sm text-secondary-900">
          <i className="ri-checkbox-circle-line mr-1.5 align-middle text-primary-600" />
          订阅成功，最新的出圈话题会第一时间发送到你的邮箱。
        </p>
      )}
      {status === "error" && (
        <p className="mt-3 rounded-md bg-primary-100 px-4 py-3 text-sm text-primary-800">
          <i className="ri-error-warning-line mr-1.5 align-middle" />
          {formError}
        </p>
      )}
      <p className="mt-3 text-xs text-foreground-500">
        我们只会用它来发送话题榜单与扩散复盘，不会用于其他用途，也不会泄露你的邮箱。
      </p>
    </form>
  );
}